module.exports = __webpack_public_path__ + "img/batch-processing.40a17101.png";